/** Crop aspect presets aligned with webshop-engine section layouts. */
export const ASPECT_PRESETS = {
  original: {
    id: "original",
    label: "Original (full image)",
    aspect: undefined,
    skipCrop: true,
    hint: "Keep the whole image — no forced crop",
  },
  free: {
    id: "free",
    label: "Free crop",
    aspect: undefined,
    hint: "Crop any shape you want",
  },
  banner: {
    id: "banner",
    label: "Banner (16:9)",
    aspect: 16 / 9,
    minWidth: 2400,
    minHeight: 1350,
    hint: "Hero banners and full-width sections",
  },
  product: {
    id: "product",
    label: "Product (3:4)",
    aspect: 3 / 4,
    minWidth: 1200,
    minHeight: 1600,
    hint: "Product cards, half-banner panels, detail gallery",
  },
  square: {
    id: "square",
    label: "Square (1:1)",
    aspect: 1,
    minWidth: 800,
    minHeight: 800,
    hint: "Category tiles and promo grids",
  },
  logo: {
    id: "logo",
    label: "Logo (3:1)",
    aspect: 3,
    minWidth: 360,
    minHeight: 120,
    hint: "Header logo - wide format",
  },
  wide: {
    id: "wide",
    label: "Wide (21:9)",
    aspect: 21 / 9,
    minWidth: 1680,
    minHeight: 720,
    hint: "Cinematic hero strips",
  },
  portrait: {
    id: "portrait",
    label: "Portrait (4:5)",
    aspect: 4 / 5,
    minWidth: 960,
    minHeight: 1200,
    hint: "Editorial and social-style crops",
  },
};

export function getAspectPreset(id) {
  if (!id) return ASPECT_PRESETS.free;
  return ASPECT_PRESETS[id] || ASPECT_PRESETS.free;
}

export const PRESET_OPTIONS = Object.values(ASPECT_PRESETS).map((p) => ({
  value: p.id,
  label: p.label,
}));
